/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';

import { MILLISECONDS_IN_A_SECOND } from '../../config';
import { TVideoPlaybackStatsList } from '../../core/videoplayer/types/TVideoPlaybackStatsList';
import { VideoPlaybackStats } from '../../core/videoplayer/utils/VideoPlaybackStats';

import './StreamStats.scss';

const StreamStats: FunctionComponent = (): JSX.Element => {
    const videoPlaybackStatsIns = new VideoPlaybackStats();
    const videoPlaybackStats: TVideoPlaybackStatsList =
        videoPlaybackStatsIns.getVideoPlaybackStats();
    const [, setTime] = useState(new Date());
    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, MILLISECONDS_IN_A_SECOND);

        return () => clearInterval(interval);
    }, []);

    const data = new Map<string, string>();

    data.set('Channel/Asset ID', videoPlaybackStats.channelCallSign);
    data.set('Resolution/Rate', videoPlaybackStats.resolutionRate);
    data.set('Connection Speed', videoPlaybackStats.connectionSpeed);
    data.set('Bitrate Used', videoPlaybackStats.biteRate);
    data.set('Buffer Available', videoPlaybackStats.bufferAvailable);
    data.set('Dropped Frames', videoPlaybackStats.droppedFrames);
    data.set('Codec & DRM', videoPlaybackStats.codecAndDrm);
    data.set('Variants', videoPlaybackStats.varients);
    data.set('Streaming URL', videoPlaybackStats.streamUrl);
    data.set('Audio Track', videoPlaybackStats.audioTrack);
    data.set('CC Track Available', videoPlaybackStats.ccTracks);
    data.set('User Agent', videoPlaybackStats.userAgent);
    data.set('Video Playback Type', videoPlaybackStats.videoPlaybackType);

    return (
        <div className="stream-stats">
            {Array.from(data).map(([key, value]) => (
                <div key={key}>
                    <span className="stream-stats-keys">{`${key} :`} </span>
                    <span className="">{value}</span>
                </div>
            ))}
        </div>
    );
};

export default StreamStats;
